import { html, ViewTemplate } from '@microsoft/fast-element';
import type { TabButtons } from './tab-buttons';

export const TabButtonsTemplate: ViewTemplate<TabButtons> = html`
  <div class="tab-buttons">
    <slot name="buttons"></slot>
  </div>
`;
